module.exports = __webpack_public_path__ + "media/images/posts/eco_nature-537224b53a9982ef6e0313e465d2fdb9.jpg";